import { render, staticRenderFns } from "./SelectDirectionComponent.vue?vue&type=template&id=2b88f56e&scoped=true&"
import script from "./SelectDirectionComponent.vue?vue&type=script&lang=js&"
export * from "./SelectDirectionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b88f56e",
  null
  
)

export default component.exports